import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=74cf6722&scoped=true&lang=pug&"
import script from "./TopPage.vue?vue&type=script&lang=ts&"
export * from "./TopPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf6722",
  null
  
)

export default component.exports